import Toastify from "toastify-js";
import { getLocalParticipant, getParticipantById, isWhiteboardParticipant } from "../../base/participants/functions";
import { getCameraParticipant } from "../../camera-participant/funcions";
import { shareBlobImage } from "../../collab-images/actions";
import { ENDPOINT_MESSAGE_RECEIVED_TAKE_CAPTURE_OF_PARTICIPANT } from "../../collab-images/constants";
import html2canvas from "html2canvas";
function showErrorToast(text) {
    Toastify({
        text,
        duration: 3000,
        close: false,
        gravity: 'top',
        position: 'right',
        backgroundColor: '#F44336',
        stopOnFocus: true
    }).showToast();
}
class ToastError extends Error {
    constructor(message) {
        super(message);
    }
}
function validateInitialStates(store) {
    const { getState } = store;
    const { conference } = getState()['features/base/conference'];
    const { participantId } = getState()['features/large-video'];
    const localParticipant = getLocalParticipant(getState);
    const participant = participantId ? getParticipantById(getState, participantId) : undefined;
    if (!conference || !participantId || !localParticipant || !participant) {
        throw new ToastError('No se pudo obtener los datos de la videoconferencia.');
    }
    if (isWhiteboardParticipant(participant)) {
        throw new ToastError('No puedes sacar una foto de la pizarra, prueba a exportar la pizarra.');
    }
    return {
        localParticipant,
        participant,
        conference,
    };
}
function validateOdontoConectaStates(store) {
    const { getState } = store;
    const { isEnabled } = getState()['features/tego-server'];
    if (!isEnabled)
        throw new ToastError("Caracteristicas de OdontoConecta no configuradas.");
    const { excalidrawApi } = getState()['features/collab-images'];
    if (!excalidrawApi)
        throw new ToastError("La pizarra no esta activada.");
    return { excalidrawApi, isEnabled };
}
export async function blobFromCamera(cameraDeviceId, isFlipped = false) {
    if (!navigator.mediaDevices?.getUserMedia) {
        throw new ToastError("getUserMedia not supported");
    }
    // Validar si el dispositivo existe
    const devices = await navigator.mediaDevices.enumerateDevices();
    if (!devices.some(d => d.deviceId === cameraDeviceId)) {
        throw new ToastError(`Camera device not found: ${cameraDeviceId}`);
    }
    // Inicializar stream
    const stream = await navigator.mediaDevices.getUserMedia({
        video: { deviceId: { exact: cameraDeviceId } }
    });
    // Configurar video temporal
    const video = Object.assign(document.createElement("video"), {
        srcObject: stream,
        muted: true,
        playsInline: true
    });
    await video.play();
    // Esperar a que tenga dimensiones válidas
    await new Promise(resolve => {
        const check = () => {
            if (video.videoWidth > 0 && video.videoHeight > 0)
                resolve();
            else
                requestAnimationFrame(check);
        };
        check();
    });
    // Capturar frame en canvas
    const canvas = Object.assign(document.createElement("canvas"), {
        width: video.videoWidth,
        height: video.videoHeight
    });
    const ctx = canvas.getContext("2d");
    if (isFlipped) {
        // Invertir horizontalmente
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
    }
    // Dibujar imagen
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    // Convertir a Blob
    const blob = await new Promise((resolve, reject) => canvas.toBlob(b => (b ? resolve(b) : reject("Canvas to Blob failed")), "image/png"));
    // Limpieza
    stream.getTracks().forEach(t => t.stop());
    video.remove();
    canvas.remove();
    return blob;
}
function successToast() {
    Toastify({
        text: '¡Peticion de captura realizada con éxito!',
        duration: 3000,
        close: false,
        gravity: 'top',
        position: 'right',
        backgroundColor: '#4CAF50',
        stopOnFocus: true
    }).showToast();
}
export async function requestCapture() {
    try {
        //@ts-ignore
        const store = APP.store;
        const { getState, dispatch } = store;
        const { localParticipant, participant, conference } = validateInitialStates(store);
        const isFlipped = getState()['features/flip'].participantIds.includes(participant.id);
        if (localParticipant.id == participant.id) {
            if (!localParticipant.cameraDeviceId)
                throw new ToastError("No se encontro la camara");
            const blob = await blobFromCamera(localParticipant.cameraDeviceId, isFlipped);
            const { excalidrawApi } = validateOdontoConectaStates(store);
            dispatch(shareBlobImage(blob, excalidrawApi, (success) => {
                if (success) {
                    successToast();
                }
            }));
        }
        else {
            const cameraParticipant = getCameraParticipant(getState, participant.id);
            if (cameraParticipant) {
                const blob = await blobFromCamera(cameraParticipant.deviceId, isFlipped);
                const { excalidrawApi } = validateOdontoConectaStates(store);
                dispatch(shareBlobImage(blob, excalidrawApi, (success) => {
                    if (success) {
                        successToast();
                    }
                }));
            }
            else {
                conference.sendMessage({
                    type: ENDPOINT_MESSAGE_RECEIVED_TAKE_CAPTURE_OF_PARTICIPANT,
                    payload: {
                        participantId: participant.id,
                        fromParticipantId: localParticipant.id,
                    }
                });
            }
        }
    }
    catch (error) {
        if (error instanceof ToastError) {
            showErrorToast(error.message);
        }
        else {
            showErrorToast("Ha ocurrio un error");
        }
    }
}
/**
 *  Agrega el efecto de flash al elemento que contiene la imagen objetiva.
 *
 * @param { HTMLElement } target - Objetivo para  agregar el efecto de flash.
 * @returns {void}
 */
function flashEffect() {
    const target = document.getElementById('largeVideoWrapper');
    if (!target) {
        console.error(`Elemento con id "${target}" no encontrado`);
        return;
    }
    const overlay = createEffectDiv();
    target.appendChild(overlay);
    overlay.style.opacity = '1';
    setTimeout(() => {
        overlay.style.opacity = '0';
    }, 100);
    console.log('Por lo menos si pasa');
}
function createEffectDiv() {
    const div = document.createElement('div');
    div.className = 'flash-overlay';
    div.style.position = 'absolute';
    div.style.top = '0';
    div.style.left = '0';
    div.style.width = '100%';
    div.style.height = '100%';
    div.style.background = 'white';
    div.style.opacity = '0';
    div.style.pointerEvents = 'none';
    div.style.transition = 'opacity 0.3s ease-in-out';
    div.style.zIndex = '10';
    return div;
}
function canvasToBlob(canvas, type = 'image/png') {
    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
            if (blob) {
                resolve(blob);
            }
            else {
                reject(new Error('No se pudo generar el blob.'));
            }
        }, type);
    });
}
export async function captureLargeVideo() {
    try {
        //@ts-ignore
        const store = APP.store;
        const { dispatch, getState } = store;
        const { participant } = validateInitialStates(store);
        const element = document.getElementById('largeVideo');
        if (!element)
            throw new ToastError('No hay ninguna cámara seleccionada como principal.');
        const isFlipped = getState()['features/flip'].participantIds.includes(participant.id);
        let canvas = await html2canvas(element);
        // 🔄 Aplicar flip horizontal si corresponde
        if (isFlipped) {
            const flippedCanvas = document.createElement("canvas");
            flippedCanvas.width = canvas.width;
            flippedCanvas.height = canvas.height;
            const ctx = flippedCanvas.getContext("2d");
            ctx.translate(flippedCanvas.width, 0); // mover origen a la derecha
            ctx.scale(-1, 1); // invertir horizontalmente
            ctx.drawImage(canvas, 0, 0); // dibujar la captura invertida
            canvas = flippedCanvas;
        }
        const blob = await canvasToBlob(canvas);
        if (!blob)
            throw new ToastError('No hay ninguna cámara seleccionada como principal.');
        flashEffect();
        Toastify({
            text: '¡Captura realizada con éxito!',
            duration: 3000,
            close: false,
            gravity: 'top',
            position: 'right',
            backgroundColor: '#4CAF50',
            stopOnFocus: true
        }).showToast();
        const item = new ClipboardItem({ 'image/png': blob });
        await navigator.clipboard.write([item]);
        const { excalidrawApi } = validateOdontoConectaStates(store);
        dispatch(shareBlobImage(blob, excalidrawApi));
    }
    catch (error) {
        if (error instanceof ToastError) {
            showErrorToast(error.message);
        }
        else {
            showErrorToast("Ha ocurrio un error");
        }
    }
}
export async function handleCapture() {
    //@ts-ignore
    const store = APP.store;
    const { localParticipant, participant } = validateInitialStates(store);
    if (localParticipant.id == participant.id) {
        captureLargeVideo();
    }
    else {
        requestCapture();
    }
}
